/**
 * Avatar fallback. "Anders Olsen" → "AO", "Stian" → "S", "" → "?".
 * Drops non-letter tokens (Jr., III) for cleaner two-letter avatars.
 */
export const initialsOf = (name: string | null | undefined): string => {
  if (!name) return '?'
  const parts = name.split(/\s+/).filter((p) => /^[\p{Letter}]/u.test(p))
  if (parts.length === 0) return name.charAt(0).toUpperCase() || '?'
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase()
}
